import { Button, Notice } from '@bennows/boows-react';
import { useTranslation } from 'react-i18next';
import { NavButton } from './NavButton';
import type { SendError } from './useAssistantChat';

interface Props {
  readonly error: SendError;
  readonly onNewConversation: () => void;
}

/** Why a message did not start, and the one thing to do about it (spec 110 section 4.15.6: budget, offline, limits). */
export function SendErrorNotice({ error, onNewConversation }: Props) {
  const { t } = useTranslation();
  const action =
    error === 'budget' ? (
      <NavButton to="/settings/billing" variant="secondary">
        {t('assistant.error.budget.topUp')}
      </NavButton>
    ) : error === 'limit' || error === 'closed' ? (
      <Button variant="secondary" size="sm" onClick={onNewConversation}>
        {t('assistant.error.newConversation')}
      </Button>
    ) : undefined;
  return (
    <Notice tone={error === 'inProgress' ? 'warning' : 'danger'} role="alert" title={t(`assistant.error.${error}.title`)} actions={action}>
      {t(`assistant.error.${error}.text`)}
    </Notice>
  );
}
